import axios from 'axios';
import { Action, handleRecaptcha } from './utils/reCAPTCHA';
export const axiosInterceptors = () => {

axios.interceptors.request.use(
    async (config) => {
      const action = Action.READ;
      const url=config.url;
      if (config.method === 'get'  && 
          (hasEndpoint(config,'get_branch_kiosk_settings') ||
          hasEndpoint(config,'groups_services_tree') ||
          hasEndpoint(config,'services_active'))) {
          const token = await handleRecaptcha(action);
          config.params = {
          ...config.params,
          reCaptchaCode: token,
          areaId: localStorage.getItem("area_id") ? localStorage.getItem("area_id") : 0
        };
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
const hasEndpoint = (config, endpoint) => {
    return config.url.includes(endpoint);
};
  